module.exports = __webpack_public_path__ + "static/media/clipboard.da2b051d.svg";